// Kannada translations for Sri Sode Vadiraja Matha
// Keys are stable identifiers; values are { en, kn }
export const TRANSLATIONS = {
  // Site & Nav
  "site.name": { en: "Sri Sode Vadiraja Matha", kn: "ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠ" },
  "site.tagline": {
    en: "Preserving the Eternal Legacy of Sri Vadiraja Theertha and the Dvaita Tradition",
    kn: "ಶ್ರೀ ವಾದಿರಾಜ ತೀರ್ಥರ ಶಾಶ್ವತ ಪರಂಪರೆ ಹಾಗೂ ದ್ವೈತ ಸಿದ್ಧಾಂತವನ್ನು ಪೋಷಿಸುತ್ತಿರುವ ಪವಿತ್ರ ಪೀಠ",
  },

  // Nav labels
  "nav.home": { en: "Home", kn: "ಮುಖಪುಟ" },
  "nav.about": { en: "About", kn: "ಪರಿಚಯ" },
  "nav.about.sode": { en: "About Sode Matha", kn: "ಸೋದೆ ಮಠದ ಬಗ್ಗೆ" },
  "nav.about.bhootharaja": { en: "About Sri Bhootharaja", kn: "ಶ್ರೀ ಭೂತಾರಾಜ ಬಗ್ಗೆ" },
  "nav.about.lineage": { en: "Lineage & Legacy", kn: "ಗುರುಪರಂಪರೆ ಮತ್ತು ಪರಂಪರೆ" },
  "nav.about.branches": { en: "Branches", kn: "ಶಾಖೆಗಳು" },
  "nav.deities": { en: "Deities", kn: "ದೇವರುಗಳು" },
  "nav.activities": { en: "Activities", kn: "ಚಟುವಟಿಕೆಗಳು" },
  "nav.activities.publications": { en: "Publications", kn: "ಪ್ರಕಟಣೆಗಳು" },
  "nav.activities.institutions": { en: "Institutions", kn: "ಸಂಸ್ಥೆಗಳು" },
  "nav.events": { en: "Events", kn: "ಕಾರ್ಯಕ್ರಮಗಳು" },
  "nav.gallery": { en: "Gallery", kn: "ಗ್ಯಾಲರಿ" },
  "nav.sevas": { en: "Sevas", kn: "ಸೇವೆಗಳು" },
  "nav.contact": { en: "Contact", kn: "ಸಂಪರ್ಕ" },
  "nav.bookRoom": { en: "Book Room", kn: "ಕೊಠಡಿ ಕಾಯ್ದಿರಿಸಿ" },
  "nav.bookSeva": { en: "Book Seva", kn: "ಸೇವೆ ಕಾಯ್ದಿರಿಸಿ" },

  // Top strip
  "top.templeHours": { en: "Temple Timings: Morning 5:00AM - 8:00AM • Evening 5:30PM - 7:30PM", kn: "ದೇವಸ್ಥಾನ ಸಮಯ: ಬೆಳಿಗ್ಗೆ ೫:೦೦ ರಿಂದ ೮:೦೦ ರವರೆಗೆ • ಸಂಜೆ ೫:೩೦ ರಿಂದ ೭:೩೦ ರವರೆಗೆ" },
  "top.today": { en: "Today", kn: "ಇಂದು" },

  // Common
  "common.readMore": { en: "Read more", kn: "ಇನ್ನಷ್ಟು ಓದಿ" },
  "common.learnMore": { en: "Learn more", kn: "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ" },
  "common.viewAll": { en: "View all", kn: "ಎಲ್ಲವನ್ನೂ ನೋಡಿ" },
  "common.back": { en: "Back", kn: "ಹಿಂದಕ್ಕೆ" },
  "common.next": { en: "Next", kn: "ಮುಂದೆ" },
  "common.proceed": { en: "Proceed", kn: "ಮುಂದೆ ಸಾಗಿ" },
  "common.submit": { en: "Submit", kn: "ಸಲ್ಲಿಸಿ" },
  "common.cancel": { en: "Cancel", kn: "ರದ್ದುಗೊಳಿಸಿ" },
  "common.email": { en: "Email", kn: "ಇಮೇಲ್" },
  "common.phone": { en: "Phone", kn: "ದೂರವಾಣಿ" },
  "common.address": { en: "Address", kn: "ವಿಳಾಸ" },
  "common.officeHours": { en: "Office Hours", kn: "ಕಚೇರಿ ಸಮಯ" },

  // Home hero
  "home.hero.eyebrow": { en: "Sri Sode Vadiraja Matha", kn: "ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠ" },
  "home.hero.title": { en: "A living legacy", kn: "ಜೀವಂತ ಪರಂಪರೆ" },
  "home.hero.subtitle": {
    en: "",
    kn: "ಶ್ರೀ ವಾದಿರಾಜ ತೀರ್ಥರ ಏಳು ಶತಮಾನಗಳ ಪರಂಪರೆಯಲ್ಲಿ ಬೇರೂರಿರುವ ಸೋದೆ ಮಠವು ದ್ವೈತ ವೇದಾಂತ, ಭಕ್ತಿ ಮತ್ತು ಧಾರ್ಮಿಕ ಸೇವೆಯ ದೀಪಸ್ತಂಭವಾಗಿದೆ.",
  },

  // Home sections
  "home.pillars.eyebrow": { en: "Pillars of an ancient tradition", kn: "ಪ್ರಾಚೀನ ಪರಂಪರೆಯ ಆಧಾರಸ್ತಂಭಗಳು" },
  "home.pillars.title": { en: "Six pillars, one path", kn: "ಆರು ಆಧಾರಸ್ತಂಭಗಳು, ಒಂದೇ ಮಾರ್ಗ" },
  "home.explore.eyebrow": { en: "Explore the Matha", kn: "ಮಠವನ್ನು ಪರಿಶೀಲಿಸಿ" },
  "home.explore.title": { en: "Legacy in every direction", kn: "ಎಲ್ಲಾ ದಿಕ್ಕುಗಳಲ್ಲಿಯೂ ಪರಂಪರೆ" },
  "home.videos.eyebrow": { en: "Watch the Matha", kn: "ಮಠವನ್ನು ವೀಕ್ಷಿಸಿ" },
  "home.videos.title": { en: "Discourses & festivals", kn: "ಪ್ರವಚನಗಳು ಮತ್ತು ಉತ್ಸವಗಳು" },
  "home.quickAccess.title": { en: "Quick Access", kn: "ತ್ವರಿತ ಪ್ರವೇಶ" },
  "home.deities.eyebrow": { en: "Sanctum • Darshana", kn: "ಗರ್ಭಗುಡಿ • ದರ್ಶನ" },
  "home.deities.title": { en: "Divine deities of Sode Matha", kn: "ಸೋದೆ ಮಠದ ದೇವಮೂರ್ತಿಗಳು" },
  "home.deities.subtitle": {
    en: "Experience the sacred presence of the deities worshipped daily in the unbroken Dvaita tradition.",
    kn: "ಅಚ್ಛೇದಿತ ದ್ವೈತ ಪರಂಪರೆಯಲ್ಲಿ ಪ್ರತಿನಿತ್ಯ ಪೂಜಿಸಲ್ಪಡುವ ದೇವಮೂರ್ತಿಗಳ ಪವಿತ್ರ ಸಾನ್ನಿಧ್ಯವನ್ನು ಅನುಭವಿಸಿ.",
  },
  "home.deities.viewAll": { en: "View all deities", kn: "ಎಲ್ಲಾ ದೇವರುಗಳನ್ನು ನೋಡಿ" },

  // About page
  "about.hero.eyebrow": { en: "About Sode Matha", kn: "ಸೋದೆ ಮಠದ ಬಗ್ಗೆ" },
  "about.hero.title": { en: "An unbroken tradition of devotion and scholarship.", kn: "ಭಕ್ತಿ ಮತ್ತು ಜ್ಞಾನದ ಅಚ್ಛೇದಿತ ಪರಂಪರೆ." },
  "about.hero.subtitle": {
    en: "Sode Śrī Vādirāja Maṭha - Sode, also known as Sonda or Svādi, is one of the most sacred kṣetras of the Mādhva tradition. It is the headquarters of Śrī Sode Vādirāja Maṭha, one of the Aṣṭa Maṭhas of Udupi belonging to the lineage established by Śrī Madhvācārya.",
    kn: "ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠವು ಉಡುಪಿಯ ಪ್ರತಿಷ್ಠಿತ ಅಷ್ಟಮಠಗಳಲ್ಲಿ ಒಂದಾಗಿದ್ದು, ಇದನ್ನು 13ನೇ ಶತಮಾನದ ದ್ವೈತ ತತ್ವಜ್ಞಾನಿ ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಸ್ಥಾಪಿಸಿದರು. ಮೂಲತಃ 'ಕುಂಭಾಸಿ ಮಠ' ಎಂದು ಕರೆಯಲ್ಪಡುತ್ತಿದ್ದ ಇದರ ಕೇಂದ್ರ ಕಚೇರಿಯು, ಮಹಾನ್ ಸಂತ-ಕವಿ ಶ್ರೀ ವಾದಿರಾಜ ತೀರ್ಥರೊಂದಿಗಿನ ಐತಿಹಾಸಿಕ ಸಂಬಂಧದ ಕಾರಣದಿಂದಾಗಿ ನಂತರ ಉತ್ತರ ಕನ್ನಡ ಜಿಲ್ಲೆಯ ಸೋದೆಗೆ (ಸೊಂಡಾ) ಸ್ಥಳಾಂತರಗೊಂಡಿತು.",
  },

  // Lineage page
  "lineage.hero.eyebrow": { en: "Lineage & Legacy", kn: "ಗುರುಪರಂಪರೆ ಮತ್ತು ಪರಂಪರೆ" },
  "lineage.hero.title": { en: "The unbroken guru parampara.", kn: "ಅಚ್ಛೇದಿತ ಗುರುಪರಂಪರೆ." },
  "lineage.hero.subtitle": {
    en: "From Sri Madhvacharya to the present Peethadhipati, an eternal chain of dvaita masters.",
    kn: "ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರಿಂದ ಇಂದಿನ ಪೀಠಾಧಿಪತಿಗಳ ವರೆಗೆ, ದ್ವೈತ ಗುರುಗಳ ಶಾಶ್ವತ ಪರಂಪರೆ.",
  },

  // Deities
  "deities.hero.eyebrow": { en: "Deities", kn: "ದೇವರುಗಳು" },
  "deities.hero.title": { en: "The sacred idols of Sode Matha.", kn: "ಸೋದೆ ಮಠದ ಪವಿತ್ರ ಮೂಲ ವಿಗ್ರಹಗಳು." },
  "deities.hero.subtitle": {
    en: "Presented by Sri Vadiraja Theertha and worshipped by an unbroken lineage of Peethadhipatis.",
    kn: "ಶ್ರೀ ವಾದಿರಾಜ ತೀರ್ಥರಿಂದ ಪ್ರತಿಷ್ಠಾಪಿಸಲ್ಪಟ್ಟು, ಅಚ್ಛೇದಿತ ಪೀಠಾಧಿಪತಿ ಪರಂಪರೆಯಿಂದ ಪೂಜಿಸಲ್ಪಡುತ್ತಿರುವ ದೇವಮೂರ್ತಿಗಳು.",
  },

  // Branches
  "branches.hero.eyebrow": { en: "Branch Mathas", kn: "ಶಾಖಾ ಮಠಗಳು" },
  "branches.hero.title": { en: "Various branches of Sri Sode Vadiraja Matha", kn: "ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠದ ಹೆಚ್ಚು ಶಾಖಾಗಳು" },
  "branches.hero.subtitle": {
    en: "Sode Matha's spiritual presence extends across India through its branch Mathas - each a centre of worship, discourse and community service.",
    kn: "ಸೋದೆ ಮಠದ ಆಧ್ಯಾತ್ಮಿಕ ಸಾನ್ನಿಧ್ಯವು ಭಾರತದಾದ್ಯಂತ ಶಾಖಾ ಮಠಗಳ ಮೂಲಕ ಹರಡಿದೆ - ಪ್ರತಿಯೊಂದೂ ಪೂಜೆ, ಪ್ರವಚನ ಮತ್ತು ಸಮಾಜ ಸೇವೆಯ ಕೇಂದ್ರವಾಗಿದೆ.",
  },

  // Events
  "events.hero.eyebrow": { en: "Events at the Matha", kn: "ಮಠದಲ್ಲಿ ಕಾರ್ಯಕ್ರಮಗಳು" },
  "events.hero.title": { en: "Sacred celebrations & gatherings", kn: "ಪವಿತ್ರ ಆಚರಣೆಗಳು ಮತ್ತು ಸಮಾವೇಶಗಳು" },
  "events.hero.subtitle": {
    en: "Festivals, jayantis, discourses, cultural events and community programmes - the pulse of daily and seasonal life at Sri Sode Vadiraja Matha.",
    kn: "ಉತ್ಸವಗಳು, ಜಯಂತಿಗಳು, ಪ್ರವಚನಗಳು, ಸಾಂಸ್ಕೃತಿಕ ಹಾಗೂ ಸಮುದಾಯ ಕಾರ್ಯಕ್ರಮಗಳು - ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠದ ದೈನಿಕ ಜೀವನದ ಸ್ಪಂದನ.",
  },

  // Gallery
  "gallery.hero.eyebrow": { en: "Gallery", kn: "ಗ್ಯಾಲರಿ" },
  "gallery.hero.title": { en: "The Matha in images.", kn: "ಚಿತ್ರಗಳಲ್ಲಿ ಮಠ." },
  "gallery.hero.subtitle": {
    en: "Photographs from the temple, festivals, discourses and community events.",
    kn: "ದೇವಸ್ಥಾನ, ಉತ್ಸವಗಳು, ಪ್ರವಚನಗಳು ಹಾಗೂ ಸಮುದಾಯ ಕಾರ್ಯಕ್ರಮಗಳ ಛಾಯಾಚಿತ್ರಗಳು.",
  },
  "gallery.videos.eyebrow": { en: "Video Gallery", kn: "ವೀಡಿಯೊ ಗ್ಯಾಲರಿ" },
  "gallery.videos.title": { en: "Watch the Matha", kn: "ಮಠವನ್ನು ವೀಕ್ಷಿಸಿ" },
  "gallery.videos.subtitle": {
    en: "Latest videos from the Sri Sode Vadiraja Matha channel - discourses, festivals and temple tours.",
    kn: "ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠದ ಚಾನೆಲ್‌ನ ಇತ್ತೀಚಿನ ವೀಡಿಯೊಗಳು - ಪ್ರವಚನಗಳು, ಉತ್ಸವಗಳು ಮತ್ತು ದೇವಸ್ಥಾನ ದರ್ಶನ.",
  },

  // Sevas
  "sevas.hero.eyebrow": { en: "Book a Seva", kn: "ಸೇವೆ ಕಾಯ್ದಿರಿಸಿ" },
  "sevas.hero.title": { en: "Seva Booking", kn: "ಸೇವಾ ಬುಕಿಂಗ್" },
  "sevas.step1.title": { en: "Select one or more sevas", kn: "ಒಂದು ಅಥವಾ ಹೆಚ್ಚು ಸೇವೆಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿ" },
  "sevas.step1.desc": {
    en: "Tap a card to add or remove it from your basket. You can offer multiple sevas in a single booking.",
    kn: "ಬಸ್ಕೆಟ್‌ಗೆ ಸೇರಿಸಲು ಅಥವಾ ತೆಗೆದುಹಾಕಲು ಕಾರ್ಡ್ ಟ್ಯಾಪ್ ಮಾಡಿ. ಒಂದೇ ಬುಕಿಂಗ್‌ನಲ್ಲಿ ಹಲವಾರು ಸೇವೆಗಳನ್ನು ಸಮರ್ಪಿಸಬಹುದು.",
  },
  "sevas.basket.title": { en: "Your basket", kn: "ನಿಮ್ಮ ಬಸ್ಕೆಟ್" },
  "sevas.basket.empty": { en: "No sevas selected yet. Pick from the list.", kn: "ಇನ್ನೂ ಯಾವುದೇ ಸೇವೆ ಆಯ್ಕೆಯಾಗಿಲ್ಲ. ಪಟ್ಟಿಯಿಂದ ಆಯ್ಕೆ ಮಾಡಿ." },
  "sevas.basket.total": { en: "Total", kn: "ಒಟ್ಟು" },
  "sevas.basket.selected": { en: "selected", kn: "ಆಯ್ಕೆಯಾಗಿದೆ" },
  "sevas.step2.title": { en: "Devotee details", kn: "ಭಕ್ತರ ವಿವರಗಳು" },
  "sevas.field.name": { en: "Full name", kn: "ಪೂರ್ಣ ಹೆಸರು" },
  "sevas.field.phone": { en: "Phone number", kn: "ದೂರವಾಣಿ ಸಂಖ್ಯೆ" },
  "sevas.field.date": { en: "Seva date", kn: "ಸೇವಾ ದಿನಾಂಕ" },
  "sevas.field.gothra": { en: "Gothra", kn: "ಗೋತ್ರ" },
  "sevas.field.nakshatra": { en: "Nakshatra", kn: "ನಕ್ಷತ್ರ" },
  "sevas.field.address": { en: "Address", kn: "ವಿಳಾಸ" },
  "sevas.field.paymentMode": { en: "Payment mode", kn: "ಪಾವತಿ ವಿಧಾನ" },
  "sevas.proceedToPay": { en: "Proceed to pay", kn: "ಪಾವತಿಗೆ ಮುಂದೆ ಸಾಗಿ" },
  "sevas.confirm.title": { en: "Confirm & Pay", kn: "ಪುಷ್ಟೀಕರಿಸಿ ಮತ್ತು ಪಾವತಿಸಿ" },
  "sevas.done.title": { en: "Seva booked & payment successful", kn: "ಸೇವೆ ಬುಕಿಂಗ್ ಮತ್ತು ಪಾವತಿ ಯಶಸ್ವಿ" },
  "sevas.printReceipt": { en: "Print receipt", kn: "ರಶೀದಿಯನ್ನು ಮುದ್ರಿಸಿ" },
  "sevas.bookAnother": { en: "Book more sevas", kn: "ಇನ್ನಷ್ಟು ಸೇವೆಗಳನ್ನು ಬುಕ್ ಮಾಡಿ" },

  // Publications
  "publications.hero.eyebrow": { en: "Publications", kn: "ಪ್ರಕಟಣೆಗಳು" },
  "publications.hero.title": { en: "A digital library of spiritual literature.", kn: "ಆಧ್ಯಾತ್ಮಿಕ ಸಾಹಿತ್ಯದ ಡಿಜಿಟಲ್ ಗ್ರಂಥಾಲಯ." },
  "publications.hero.subtitle": {
    en: "From the tri-monthly Tatvamallika magazine to critical editions of classical Sanskrit works - decades of scholarly publishing.",
    kn: "ತ್ರೈಮಾಸಿಕ ತತ್ವಮಲ್ಲಿಕಾ ಪತ್ರಿಕೆಯಿಂದ ಶಾಸ್ತ್ರೀಯ ಸಂಸ್ಕೃತ ಗ್ರಂಥಗಳ ವಿಮರ್ಶಾತ್ಮಕ ಆವೃತ್ತಿಗಳವರೆಗೆ - ದಶಕಗಳ ಶಾಸ್ತ್ರೀಯ ಪ್ರಕಟಣಾ ಪರಂಪರೆ.",
  },
  "publications.featured": { en: "Featured Publication", kn: "ವಿಶೇಷ ಪ್ರಕಟಣೆ" },
  "publications.subscribe": { en: "Subscribe", kn: "ಚಂದಾದಾರರಾಗಿ" },
  "publications.viewArchive": { en: "View Archive", kn: "ಆರ್ಕೈವ್ ನೋಡಿ" },
  "publications.explore.eyebrow": { en: "Digital Library", kn: "ಡಿಜಿಟಲ್ ಗ್ರಂಥಾಲಯ" },
  "publications.explore.title": { en: "Explore our publications", kn: "ನಮ್ಮ ಪ್ರಕಟಣೆಗಳನ್ನು ಪರಿಶೀಲಿಸಿ" },

  // Institutions
  "institutions.hero.eyebrow": { en: "Institutions", kn: "ಸಂಸ್ಥೆಗಳು" },
  "institutions.hero.title": { en: "Nurturing knowledge rooted in values.", kn: "ಮೌಲ್ಯಾಧಾರಿತ ಜ್ಞಾನವನ್ನು ಪೋಷಿಸುತ್ತಿರುವ ಸಂಸ್ಥೆಗಳು." },
  "institutions.hero.subtitle": {
    en: "The Matha runs and supports institutions that blend timeless traditional learning with modern education, alongside charitable trusts serving society.",
    kn: "ಶಾಶ್ವತ ಸಾಂಪ್ರದಾಯಿಕ ಶಿಕ್ಷಣವನ್ನು ಆಧುನಿಕ ಶಿಕ್ಷಣದೊಂದಿಗೆ ಸಂಯೋಜಿಸುತ್ತಿರುವ ಸಂಸ್ಥೆಗಳನ್ನೂ, ಸಮಾಜ ಸೇವಾ ಟ್ರಸ್ಟುಗಳನ್ನೂ ಮಠವು ನಡೆಸುತ್ತಿದೆ.",
  },
  "institutions.grid.eyebrow": { en: "Our Institutions", kn: "ನಮ್ಮ ಸಂಸ್ಥೆಗಳು" },
  "institutions.grid.title": { en: "Centres of learning & service", kn: "ಜ್ಞಾನ ಮತ್ತು ಸೇವಾ ಕೇಂದ್ರಗಳು" },

  // Contact
  "contact.hero.eyebrow": { en: "Contact", kn: "ಸಂಪರ್ಕ" },
  "contact.hero.title": { en: "Reach the Matha.", kn: "ಮಠವನ್ನು ಸಂಪರ್ಕಿಸಿ." },
  "contact.hero.subtitle": {
    en: "Whether you seek darshana, wish to book a Seva, plan a visit, or reach out with an enquiry - the Matha welcomes you.",
    kn: "ದರ್ಶನ, ಸೇವಾ ಬುಕಿಂಗ್, ಭೇಟಿಯ ಯೋಜನೆ ಅಥವಾ ವಿಚಾರಣೆಗಾಗಿ - ಮಠವು ನಿಮ್ಮನ್ನು ಸ್ವಾಗತಿಸುತ್ತದೆ.",
  },
  "contact.officeHoursValue": { en: "6:30 AM - 9:00 PM (All Days)", kn: "ಬೆಳಗ್ಗೆ ೬:೩೦ - ರಾತ್ರಿ ೯:೦೦ (ಎಲ್ಲಾ ದಿನಗಳು)" },
  "contact.officeEveningHoursValue": { en: "Evening:5:00 PM - 8:00 PM", kn: "ಸಂಜೆ ೫:೦೦ ರಿಂದ ೮:೦೦" },
  "contact.form.title": { en: "Write to us", kn: "ನಮಗೆ ಬರೆಯಿರಿ" },
  "contact.form.eyebrow": { en: "Enquiry Form", kn: "ವಿಚಾರಣಾ ಫಾರ್ಮ್" },
  "contact.map.title": { en: "Find us on the map", kn: "ನಕ್ಷೆಯಲ್ಲಿ ನಮ್ಮನ್ನು ಹುಡುಕಿ" },
  "contact.map.eyebrow": { en: "Location", kn: "ಸ್ಥಳ" },

  // Room Booking
  "rooms.hero.eyebrow": { en: "Stay at the Matha", kn: "ಮಠದಲ್ಲಿ ವಾಸ" },
  "rooms.hero.title": { en: "Book your stay for darshana.", kn: "ದರ್ಶನಕ್ಕಾಗಿ ವಸತಿ ಕಾಯ್ದಿರಿಸಿ." },
  "rooms.hero.subtitle": {
    en: "Comfortable accommodation for devotees visiting Sri Sode Vadiraja Matha at Sonda.",
    kn: "ಸೋಂದದ ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠಕ್ಕೆ ಭೇಟಿ ನೀಡುವ ಭಕ್ತರಿಗಾಗಿ ಆರಾಮದಾಯಕ ವಸತಿ.",
  },

  // Footer
  "footer.explore": { en: "Explore", kn: "ಪರಿಶೀಲಿಸಿ" },
  "footer.timings": { en: "Temple Timings", kn: "ದೇವಸ್ಥಾನ ಸಮಯಗಳು" },
  "footer.contact": { en: "Contact", kn: "ಸಂಪರ್ಕ" },
  "footer.support": { en: "Support the Matha", kn: "ಮಠಕ್ಕೆ ಸಹಕರಿಸಿ" },
  "footer.aboutSode": { en: "About Sode Matha", kn: "ಸೋದೆ ಮಠದ ಬಗ್ಗೆ" },
  "footer.vadiraja": { en: "Sri Vadiraja Theertha", kn: "ಶ್ರೀ ವಾದಿರಾಜ ತೀರ್ಥ" },
  "footer.parampara": { en: "Guru Parampara", kn: "ಗುರುಪರಂಪರೆ" },
  "footer.deities": { en: "Deities", kn: "ದೇವರುಗಳು" },
  "footer.festivals": { en: "Festivals", kn: "ಉತ್ಸವಗಳು" },
  "footer.publications": { en: "Publications", kn: "ಪ್ರಕಟಣೆಗಳು" },
  "footer.gallery": { en: "Gallery", kn: "ಗ್ಯಾಲರಿ" },
  "footer.legacyDesc": {
    en: "A living spiritual institution rooted in Dvaita philosophy - preserving the eternal legacy of Sri Vadiraja Theertha through worship, scholarship and service.",
    kn: "ದ್ವೈತ ದರ್ಶನದಲ್ಲಿ ಬೇರೂರಿರುವ ಜೀವಂತ ಆಧ್ಯಾತ್ಮಿಕ ಸಂಸ್ಥೆ - ಪೂಜೆ, ಜ್ಞಾನ ಹಾಗೂ ಸೇವೆಯ ಮೂಲಕ ಶ್ರೀ ವಾದಿರಾಜ ತೀರ್ಥರ ಶಾಶ್ವತ ಪರಂಪರೆಯನ್ನು ಪೋಷಿಸುತ್ತಿದೆ.",
  },
  "footer.rights": { en: "All rights reserved.", kn: "ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನೂ ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ." },
  "footer.morning": { en: "Morning Darshana", kn: "ಬೆಳಗಿನ ದರ್ಶನ" },
  "footer.afternoon": { en: "Afternoon Break", kn: "ಮಧ್ಯಾಹ್ನ ವಿಶ್ರಾಂತಿ" },
  "footer.evening": { en: "Evening Darshana", kn: "ಸಂಜೆಯ ದರ್ಶನ" },
};
